export default {"src":"/_next/static/image/public/assets/icons/star-81.c7767dc4566c675744c2e571067341ee.svg","height":16,"width":16};